export default {
  createVariable: 'Define new variable',
};
